<template>
  <div id="quantTeusEmbarques">
    <loading color="#2185d0" :active.sync="isLoading" loader="bars" :is-full-page="fullPage"></loading>
    <grafico-barra :chart-data="dados_grafico" :options="options"></grafico-barra>
  </div>
</template>
     
<script>
import GraficoBarra from "src/components/graficos/GraficoBarra.vue";

export default {
  name: "QuantTeusEmbarques",
  props: ["estatisticaInfo"],
  components: {
    GraficoBarra
  },
  data() {
    return {
      isLoading: false,
      fullPage: false,
      dados_grafico: {},
      options: {
        plugins: {
          // Change options for ALL labels of THIS CHART
          datalabels: {
            color: "white",
            backgroundColor: "#00000085",
clamp: true,
            anchor: "top"
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              stacked: true,
              ticks: {
                beginAtZero: true,
                min: 0
              }
            }
          ]
        }
      }
    };
  },
  methods: {
    getQuantTeusEmbarcados(data) {
      let url = this.$urlApi + "/api/estatisticas-teus-embarques";
      this.isLoading = true;
      this.axios.post(url, data).then(res => {
        //console.log(res.data);
        this.dados_grafico = {
          labels: res.data.label,
          datasets: [
            {
              label: "Quantidade de TEUS embarcados",
              backgroundColor: [
                "#6699FF",
                "#64D7EE",
                "#1CC8EB",
                "#2D616B",
                "#169DB8",
                "#073038",
                "#52B1C3",
                "#169DB8",
                "#183338",
                "#107185",
                "#0D5B6B"
              ],
              borderColor: "#6699FF",
              data: res.data.series
            }
          ]
        };
        this.isLoading = false;
      });
    }
  },
  watch: {
    $props: {
      handler() {
        this.getQuantTeusEmbarcados(this.$props.estatisticaInfo);
      },
      deep: true
    }
  }
};
</script>

<style>
</style>